import { useState } from "react";
import ItemModal from "./ItemModal";
import ItemRow from "./ItemRow";

export default function RateItemsStep({concepts = [],conditions = [], items = [], catalogConditions = [], places = [], onChange}) {
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const hasErrors = items.some(
    (i) => !i.value_cents || i.value_cents <= 0
  );

  return (
    <section className="card">
      <h2>Paso 4 — Ítems y reglas</h2>
      <p className="wizard-guide">
        Defina cuánto se cobra por cada concepto y en qué casos aplica.
      </p>
    
      <div className="rate-items-layout">
        {items.length === 0 && (
          <p className="muted">
            Aún no se han definido reglas tarifarias.
          </p>
        )}

        {items.length > 0 && (
          <table className="table">
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Valor</th>
                <th>Condición Aplicada</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <ItemRow
                  key={item.id}
                  item={item}
                  concepts={concepts}
                  catalogConditions={catalogConditions}
                  places={places}
                  onEdit={() => {
                    setEditingItem(item);
                    setShowModal(true);
                  }}
                />
              ))}
            </tbody>
          </table>
        )}

      {hasErrors && (
        <div className="warning-box">
          ⚠️ Existen reglas con valores inválidos.
        </div>
      )}

      <ItemModal
        show={showModal}
        concepts={concepts}
        conditions={conditions}
        initialValue={editingItem}
        onClose={() => setShowModal(false)}
        onSave={(item) => {
          onChange(
            items.map(i => i.id === item.id ? item : i)
          );
          setShowModal(false);
        }}
      />

    </div>
    </section>
    
  );
}
